import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {app}from "../firebaseConfig.js";
import  {getFirestore, collection, addDoc} from 'firebase/firestore';

const firestore = getFirestore(app);
const vendorsCollection = collection(firestore, "vendors");

function VendorRegistrationForm() {
    const [vendorName, setVendorName] = useState('');
    const [vendorEmail, setVendorEmail] = useState('');
    const [vendorType, setVendorType ] = useState('');
    const [vendorPhone, setVendorPhone] = useState('');
    const [vendorWebsite, setVendorWebsite] = useState('');
    const [vendorSocial, setVendorSocial] = useState('');




    const handleSubmit = async() => {
        try {
            //Save vendor data to Firestore
            await addDoc(vendorsCollection, { name: "Vendor Name", email: "vendor@example.com"});
            console.log("Vendor data saved sucessfully!");
        } catch (error) {
            console.error("Error saving vendor data: ", error);
        };
       
        //Create a new vendor object with the form data
        const newVendor = {
            name: vendorName,
            email: vendorEmail,
            type: vendorType,
            phone: vendorPhone,
            website: vendorWebsite,
            social: vendorSocial   
        };

    };

    return (
        <div>
            
            <h1 className="display-6">Vendor Registration Form</h1>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3 input-group">
                    <label htmlFor="vendorName" className="col-form-label col-sm-4">Vendor Name:</label>
                    <div className="col-sm-6"><input
                    type="text"
                    className="form-control"
                    id="vendorName"
                    value={vendorName}
                    onChange={(e) => setVendorName(e.target.value)}
                    />
                    </div>
                </div>
                <div className="row mb-3 input-group">
                    <label htmlFor="vendorEmail" className="col-form-label col-sm-4">Email: </label>
                    <div className="col-sm-6 mb-3"><input
                    type="email"
                    className="form-control"
                    id="vendorEmail"
                    value={vendorEmail}
                    onChange={(e) => setVendorEmail(e.target.value)}
                    />
                    </div>
                </div>
                <div className="row mb-3 input-group">
                    <label htmlFor="vendorType" className="col-form-label col-sm-4">Vendor Type:</label>
                    <div className="col-sm-6 mb-3"><input
                    type="text"
                    className="form-control"
                    id="vendorType"
                    value={vendorType}
                    onChange= {(e) => setVendorType(e.target.value)}
                    />
                    </div>
                </div>
                <div className="row mb-3 input-group">
                    <label htmlFor="vendorPhone" className="col-form-label col-sm-4">Vendor Phone Number</label>
                    <div className="col-sm-6 mb-3">
                    <input
                    type="phone"
                    className="form-control"
                    id="vendorPhone"
                    value={vendorPhone}
                    onChange={(e) => setVendorPhone(e.target.value)}
                    />
                    </div>
                </div>
                <div className="row input-group">
                    <label htmlFor="vendorWebsite" className="col-form-label col-sm-4">Website:</label>
                    <div className="col-sm-6 mb-3"><input
                    type="url"
                    class="form-control"
                    id="vendorWebsite"
                    value={vendorWebsite}
                    onChange= {(e) => setVendorWebsite(e.target.value)}
                    />
                    </div>
                </div>
                <div className="row mb-3 input-group">
                    <label htmlFor="vendorSocial" className="col-form-label col-sm-4">Vendor Social:</label>
                    <div className="col-sm-6 mb-3">
                    <input
                    type="text"
                    className="form-control"
                    id="vendorSocial"
                    value={vendorSocial}
                    onChange= {(e) => setVendorSocial(e.target.value)}
                    />
                    </div>
                </div>
               <div className="row mb-3 input-group">
                <button type="submit" className="btn btn-custom-primary">Submit</button>
                </div>
            </form>
            <p className="fs-4 text">
                Are you registered? Proceed to <Link to="/payment">Payment Form</Link>

            </p>
        </div>
    );
}

export default VendorRegistrationForm;